'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AddIcon = require('./AddIcon');

var _AddIcon2 = _interopRequireDefault(_AddIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AddIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/AddIcon/index.js
// module id = 254
// module chunks = 11